// extracted by mini-css-extract-plugin
export default {"subTab":"patientView_subTab__q4U8i"};